var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataToShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 355.491,
    height: 222.131,
    viewBox: "0 0 355.491 222.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcc7a6;}.b,.c,.d{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4px;}.b{stroke:#464545;}.b,.c{stroke-linejoin:round;}.c,.d{stroke:#898b8d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.303 -242.254)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 254.927,
    height: 84.976,
    rx: 20.667,
    transform: "translate(114.822 324.937) rotate(-3.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M314.7,421.42H142.077a14.744,14.744,0,0,1-14.744-14.744V351.188a14.744,14.744,0,0,1,14.744-14.744H367.516a14.744,14.744,0,0,1,14.744,14.744v55.488a14.744,14.744,0,0,1-14.744,14.744l-18.152.5-12.041-7.548,10.349,40.1Z",
    transform: "translate(-17.673 -26.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.585,244.556,167,254.068l9.512,2.537v9.512l9.512,1.585",
    transform: "translate(-29.041 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.646,
    cy: 3.646,
    r: 3.646,
    transform: "translate(197.252 276.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4.439,
    cy: 4.439,
    r: 4.439,
    transform: "translate(402.953 405.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M529,473.636l-27.452-10.325s-3.17-4.121,0-6.342,4.439-.634,4.439-.634l25.921,9.512",
    transform: "translate(-124.513 -60.536)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 2.22,
    x2: 33.61,
    transform: "translate(383.057 303.214)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y2: 24.098,
    transform: "translate(315.837 256.129)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 24.415,
    transform: "translate(303.789 267.702)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 17.04,
    y2: 17.04,
    transform: "translate(187.505 419.901)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 17.264,
    x2: 17.264,
    transform: "translate(187.169 419.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M92.011,501.084l11.1-1.417-1.9,10.385-11.1,1.626,1.908-10.594",
    transform: "translate(-7.003 -73.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M98.917,522.327l10.7-1.427,2.675-10.344",
    transform: "translate(-9.529 -76.232)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 7.015,
    y1: 6.698,
    transform: "translate(96.106 426.555)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.351,
    y1: 7.014,
    transform: "translate(94.203 436.941)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 6.466,
    y1: 7.528,
    transform: "translate(83.1 438.567)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 25.824,
    y2: 18.61,
    transform: "translate(375.623 417.995)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 6.341,
    x2: 30.675,
    transform: "translate(65.667 405.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M351,519v22.037l18.707-12.366Z",
    transform: "translate(-81.772 -78.652)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataToShow);
export default __webpack_public_path__ + "static/media/noDataToShow.aa10aa8368234d08b779d00535695ae6.svg";
export { ForwardRef as ReactComponent };